export default "__VITE_ASSET__sxUAJ2Iv__"